/**
 * DeployBanner — appears on Admin Dashboard top.
 * Reminds admin to push backend changes to localliink.com production.
 */
import React, { useState } from 'react';
import { Rocket, Github, X, Check } from 'lucide-react';

const STORAGE_KEY = 'localliink_deploy_banner_dismissed_v1';

export const DeployBanner = () => {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(STORAGE_KEY) === '1');
  if (dismissed) return null;
  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };
  return (
    <div className="mb-5 rounded-2xl bg-gradient-to-r from-[#1a1a1a] to-[#2d0d18] text-white p-4 sm:p-5 shadow-lg relative overflow-hidden" data-testid="deploy-banner">
      <button onClick={dismiss} aria-label="Dismiss" data-testid="deploy-banner-dismiss" className="absolute top-3 right-3 p-1 rounded-full hover:bg-white/10 text-white/60 hover:text-white">
        <X className="h-4 w-4" />
      </button>
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-12 h-12 rounded-2xl bg-[#FF0059]/20 border border-[#FF0059]/40 flex items-center justify-center flex-shrink-0">
            <Rocket className="h-6 w-6 text-[#FF0059]" />
          </div>
          <div className="min-w-0">
            <p className="font-black text-lg leading-tight">Preview &amp; production may be out of sync</p>
            <p className="text-sm text-white/70 mt-0.5">
              Save changes here are live on <span className="font-bold text-white">preview</span>. To push to{' '}
              <span className="font-bold text-[#FFCB00]">localliink.com</span> production, use{' '}
              <span className="font-bold">Save to GitHub</span> then redeploy from your Emergent dashboard.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-black font-bold text-sm hover:bg-[#FFE5EE] transition-colors"
            data-testid="deploy-banner-github"
          >
            <Github className="h-4 w-4" /> Save to GitHub
          </a>
          <button
            onClick={dismiss}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FF0059] hover:bg-[#CC0047] text-white font-bold text-sm"
            data-testid="deploy-banner-ack"
          >
            <Check className="h-4 w-4" /> Got it
          </button>
        </div>
      </div>
    </div>
  );
};
